export default {
  登录: 'เข้าสู่ระบบ',
  注册: 'ลงทะเบียนสมาชิก',
  重设密码: 'รีเซ็ตรหัสผ่าน',
  注册邮箱: 'ลงทะเบียนอีเมล',
  输入邮箱: 'ป้อนอีเมล',
  '邮箱格式不正确，请重新输入': 'รูปแบบอีเมลไม่ถูกต้อง กรุณาป้อนใหม่',
  提交: 'ส่ง',
  '验证码正在发送，请注意查收': 'รหัสยืนยันจะถูกส่งไปยังอีเมลของคุณ กรุณาตรวจสอบ',
  邮箱验证码: 'รหัสยืนยันอีเมล',
  输入验证码: 'ป้อนรหัสยืนยัน',
  新密码设置: 'ตั้งค่ารหัสผ่านใหม่',
  再次确认新密码: 'ยืนยันรหัสผ่านใหม่อีกครั้ง',
  设置你的登陆密码: 'ตั้งรหัสผ่านเข้าสู่ระบบของคุณ',
  请再次输入您的密码: 'ยืนยันรหัสผ่านใหม่อีกครั้ง',
  '验证码格式不正确，请重新输入': 'รูปแบบรหัสยืนยันไม่ถูกต้อง กรุณาป้อนใหม่',
  密码不能为空: 'รหัสผ่านต้องไม่ว่างเปล่า',
  '输入的密码格式不正确，请设置6-32位字母或数字，区分大小写。': 'รูปแบบรหัสผ่านที่ป้อนไม่ถูกต้อง โปรดตั้งตัวอักษรหรือตัวเลข 6-32 ตัว โดยคำนึงถึงตัวพิมพ์เล็กและใหญ่',
  两次密码不一致: 'รหัสผ่านทั้งสองไม่ตรงกัน'
}
